import { render, staticRenderFns } from "./zbtj.vue?vue&type=template&id=7ad35954&"
import script from "./zbtj.vue?vue&type=script&lang=js&"
export * from "./zbtj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports